import type { ChangeEvent } from "react";
import "./form-inputs.style.scss";

interface SwitchProps {
	isToggled: boolean;
	onToggle: (e: ChangeEvent<HTMLInputElement>) => void;
	name?: string;
}

function Switch({ isToggled, onToggle, name = "" }: SwitchProps) {
	return (
		<label className="switch-container">
			<input
				type="checkbox"
				name={name}
				className="switch-checkbox"
				checked={isToggled}
				onChange={onToggle}
			/>
			<span className="switch-slider" />
		</label>
	);
}

export default Switch;
